import { AssetImg } from '@app/components/Asset/AssetImg'
import { ContainerFlex } from '@app/components/Container'
import { buildVariants } from '@design-system/libs/buildVariants'
import styled, { createGlobalStyle } from 'styled-components'

export type StaticErrorProps = {
  reason: React.ReactNode
}

const GlobalStyle = createGlobalStyle(props => {
  return buildVariants(props)
    .css({
      '#app': {
        height: '100%',
        width: '100%',
        margin: 0,
        padding: 0,
        boxSizing: 'border-box',
        backgroundColor: '#1c2b45',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh'
      }
    })
    .end()
})

const Container = styled(ContainerFlex)(props => {
  return buildVariants(props)
    .css({
      height: '100%',
      width: '100%',
      backgroundColor: '#1c2b45'
    })
    .end()
})

const ContainerSub = styled(ContainerFlex)(props => {
  return buildVariants(props)
    .css({
      height: 'auto',
      width: '500px',
      backgroundColor: 'white',
      borderRadius: '10px',
      padding: '40px',
      boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.5)',
      textAlign: 'center',
      color: '#333'
    })
    .end()
})

const Top = styled.div(props => {
  return buildVariants(props)
    .css({
      height: 'auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: '20px'
    })
    .end()
})

const Logo = styled(AssetImg)(props => {
  return buildVariants(props)
    .css({
      marginBottom: '50px'
    })
    .end()
})

const Message = styled.div(props => {
  return buildVariants(props)
    .css({
      fontSize: '1rem',
      margin: '0 5px',
      color: '#1c2b45',
      marginBottom: '50px'
    })
    .end()
})

const Button = styled.a(props => {
  return buildVariants(props)
    .css({
      display: 'inline-block',
      padding: '10px 20px',

      backgroundColor: '#0b2040',
      color: 'white',
      borderRadius: '5px',
      textDecoration: 'none',
      fontSize: '0.9rem',
      transition: 'background-color 0.3s ease',

      '&:hover': {
        color: 'white',
        textDecoration: 'none',
        backgroundColor: '#1e3b65'
      }
    })
    .end()
})

/**
 * Static error page with no dependencies to stores of theme.
 * Used only when the application has crashed during the initialization.
 */
export default function StaticError(props: StaticErrorProps) {
  return (
    <>
      <GlobalStyle />

      <Container
        name="Container"
        justifyContent="center"
        alignItems="center"
        items={[
          <ContainerSub
            name="ContainerSub"
            direction="column"
            alignItems="center"
            items={[
              <Logo
                imagePath="/w/assets/images/logos"
                imageName="IE-stacked-FullColor-RGB-logo"
                fileType="svg"
                width={300}
              />,

              <Message key="message">
                {props.reason || 'Page Not Found'}
              </Message>,

              <Button href="/" key="button">
                Back to the home page
              </Button>
            ]}
          />
        ]}
      />
    </>
  )
}
